import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/.pnpm/next@14.2.0_@babel+core@7.28.5_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["CidAtmosphere"] */ "/vercel/path0/src/components/common/CidAtmosphere.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/vercel/path0/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/cid/briefs.css");
